<template>

  <div class="logo-container">

    <div class="logo"></div>

    <div class="logo-text">
      место встречи впечатлений
    </div>

  </div>

</template>

<script>

export default {

  name: 'Logo',
}

</script>

<style lang="sass" scoped>

  .logo
    width: 108px
    height: 23.62px

    background-image: url(../assets/img/logo.svg)
    background-size: contain
    background-position: center
    background-repeat: no-repeat

    margin: 0 auto

    &-container
      bottom: 17px
      position: absolute
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center

    &-text
      font-size: .6em
      margin: 0 auto
      color: white
      font-family: "VK Sans Display"
      font-weight: 400

@media (max-width: 420px)
  .logo
    width: 20vw
    height: 4.375vw

    &-container
      bottom: 1.6vh
</style>
